/* @flow */
import cx from 'classnames';
import * as React from 'react';

import { getPropClassesFromInstance } from 'lib/getPropClasses';

import './styles/Divider.scss';

/**
 * ## [Horizontal rule](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/hr) with built-in vertical padding.
 *
 *
 * ```example
 * <div>
 *   <Divider size="xlarge" />
 *   <Divider />
 *   <Divider size="medium" />
 *   <Divider size="small" />
 * </div>
 * ```
 */

type Props = {
  className?: string,
  size?: 'xxxlarge' | 'xlarge' | 'large' | 'medium' | 'small' | 'xsmall' | 'flush',
};

export default class Divider extends React.Component<Props> {
  static propClasses = {
    size: {
      xxxlarge: 'Divider--xxxlarge',
      xlarge: 'Divider--xlarge',
      large: 'Divider--large',
      medium: 'Divider--medium',
      small: 'Divider--small',
      xsmall: 'Divider--xsmall',
      flush: 'Divider--flush',
    },
  };

  static defaultProps = {
    size: 'large',
  };

  render() {
    return <hr className={cx('Divider', this.props.className, getPropClassesFromInstance(this))} />;
  }
}
